export class AppService{
  name?: string
  options?: string[]

  constructor(params?: Partial<AppService>) {
    Object.assign(this, params)
  }
}
